import { TOKEN_KEY } from '@/config'
import { getCookie, setCookie, removeCookie } from '@/core/mixins/useCookie'

export let getToken = () => getCookie(TOKEN_KEY)
export let setToken = (val, expires) => setCookie(TOKEN_KEY, val, expires)
export let removeToken = () => removeCookie(TOKEN_KEY)



export let setUserInfo = (val, expires) => setCookie("userInfo", val, expires)